import type { FC } from 'react';
import React from 'react';
import { Text } from '@alfa-bank/site-text-v2';

import type { TProgressInfo } from './models';

export const ProgressInfo: FC<TProgressInfo> = props => {
    const { isSlogan, maxValue, placeholder, progressBarFilledValue, progressBarValue, textMask } =
        props as Required<TProgressInfo>; // чтобы тс не ругался, тк форма прокидывает эти пропсы через React.cloneElement

    // Наличие слогана определяет вид прогресс бара: расширенный (с отображением шагов и доп. полосы заполнения) или обычный
    if (progressBarFilledValue === maxValue && !isSlogan) {
        return (
            <Text styler={{ marginBottom: 8, marginTop: 0 }} view="primary-small">
                Нажмите{' '}
                <Text fontSize={14} fontWeight={6} tag="span">
                    Продолжить
                </Text>
                , чтобы получить вашу X5-Карту
            </Text>
        );
    }
    const text = textMask.replace('#field#', placeholder || '').split('#');

    text.splice(
        text.indexOf('percent'),
        1,
        // @ts-ignore
        <Text key={Math.random()} fontSize={14} fontWeight={6} tag="span">
            {isSlogan ? maxValue : progressBarValue}%
        </Text>
    );

    return (
        <Text styler={{ marginBottom: 8, marginTop: 0 }} view="primary-small">
            {text}
        </Text>
    );
};
